import {IOnlineCondolenceSummary} from "../types/resources/OnlineCondolenceSummary";
import {IPost} from '../types/resources/Post';
import {IOnlineCondolenceDetails} from '../types/resources/OnlineCondolenceDetails';

class OnlineCondolenceUtils
{
    static getFullName(summary: IOnlineCondolenceSummary): string {
        const parts = [summary.friendlyName, summary.name];

        return parts.join(' ');
    }

    static getPublicPosts(detail: IOnlineCondolenceDetails): IPost[] {
        return detail.posts.filter(p => !p.isMarkedAsPrivateByAuthor);
    }

}

export default OnlineCondolenceUtils;
